import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";

const DashboardWrapper = styled.div`
  background-color: #f8f8f8;
  padding: 10px;
  display: flex;
  flex-direction: column;

  @media (min-width: ${ScreenSize.md}px) {
    border-radius: 10px;
    margin-right: 20px;
    padding: 20px;
  }
`;

export default DashboardWrapper;
